module.exports = __webpack_public_path__ + "./images/ae6f351724c5aecfdfafc07bd127d52a.webp";